import React from "react";
import { Lock } from "lucide-react";

/**
 * BlurredPreview — D7a (iter134).
 *
 * Wraps N placeholder rows/cards, renders them under a CSS blur +
 * lock chip overlay. Clicking anywhere on the overlay opens the
 * PaywallModal (via `onUnlock`).
 *
 * Server-truth-first: the parent supplies a `hiddenCount` (from the
 * backend `hidden_count` field). NEVER receives real Elite data.
 */
export default function BlurredPreview({
  hiddenCount, unit = "row", onUnlock, children,
}) {
  if (!hiddenCount || hiddenCount <= 0) return null;
  return (
    <div
      data-testid="blurred-preview"
      className="relative"
    >
      <div
        aria-hidden="true"
        className="pointer-events-none select-none"
        style={{ filter: "blur(4px)" }}
      >
        {children}
      </div>
      <button
        onClick={onUnlock}
        data-testid="blurred-preview-unlock-btn"
        className="absolute inset-0 flex items-center justify-center gap-2 bg-[var(--bt-surface)]/50 border border-dashed border-[var(--bt-accent)] rounded-sm cursor-pointer hover:bg-[var(--bt-surface)]/70 transition-colors"
      >
        <Lock className="w-4 h-4 text-[var(--bt-accent)]" />
        <span className="text-xs font-mono uppercase text-[var(--bt-text)]">
          {hiddenCount} more {unit}{hiddenCount === 1 ? "" : "s"} · Elite
        </span>
      </button>
    </div>
  );
}
